import { motion } from 'framer-motion';
import { SectionContent } from '@/contexts/ContentContext';

interface StatsPreviewProps {
  content: SectionContent;
}

export default function StatsPreview({ content }: StatsPreviewProps) {
  if (!content.stats) return null;

  return (
    <div className="space-y-4 p-4 bg-gray-50 rounded-lg">
      <div className="text-center">
        <h3 className="text-xl font-bold text-gray-900">{content.title || 'Nossos Números'}</h3>
        {content.subtitle && (
          <p className="text-gray-600 mt-1">{content.subtitle}</p>
        )}
      </div>
      
      <div className="grid grid-cols-2 gap-4 mt-6">
        {content.stats.map((stat, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="bg-white p-4 rounded-lg shadow text-center"
          >
            <div className="text-2xl font-bold text-primary-600">
              {stat.prefix || ''}{stat.number}{stat.suffix || ''}
            </div>
            <div className="text-sm text-gray-600 mt-1">{stat.label}</div>
          </motion.div>
        ))}
      </div>
      
      {content.cta && (
        <div className="mt-6 text-center">
          <button className="px-4 py-2 bg-primary-600 text-white rounded-md hover:bg-primary-700 transition-colors">
            {content.cta}
          </button>
        </div>
      )}
    </div>
  );
}
